import React from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { Iconfont } from '../../../../../../../components/icon/iconfont'
import PaypalButton from '../../../../../components/paypal-button'
import { SensorsTrack } from '../../../../../../../utils/sensor'

export default props => {
    useStyles(classes)
    const {onPaymethod, onError, isFastPayment, check, clickHandle} = props
    const eventClick = () => {
        SensorsTrack('CartAction', {
            action: `ClickPayNow_1`
        })
        clickHandle?.()
    }

    return <div className={classes.PayPal}>
        <div className={classes.Button}>
            <PaypalButton check={check} isFastPayment={isFastPayment} domId={'cart-paypal'} onError={onError} shoudBilling label="buynow" clickHandle={eventClick}/>
        </div>
        <button className={classes.Select} onClick={onPaymethod}>
            <Iconfont className={classes.Icon}>&#xe727;</Iconfont>
        </button>
    </div>
}